var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 41H34.5C38.09 41 41 38.09 41 34.5V11.5C41 7.91 38.09 5 34.5 5H11.5C7.91 5 5 7.91 5 11.5V34.5C5 38.09 7.91 41 11.5 41Z",
    fill: "#1878F3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.115 27.235H34.032L34.804 22.24H29.114V19.51C29.114 17.435 29.792 15.595 31.733 15.595H34.852V11.236C34.304 11.162 33.145 11 30.955 11C26.382 11 23.701 13.415 23.701 18.917V22.24H19V27.235H23.701V40.964C24.5 41 25.575 41.005 26.543 41.005C27.418 41.005 28 41 29.115 41.005V27.235Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFb);
export default __webpack_public_path__ + "static/media/icon_fb.7361e1f3a319deaa1593be6bc74ccb71.svg";
export { ForwardRef as ReactComponent };